import { Tooltip } from 'antd';
import React, { Component } from 'react';
import './style.css';

class BasicTextField extends Component {
	// handleKeyPress = (e) => {
	//   if (e.key === 'Enter') {
	//     if (this.props.onSubmit) {
	//       this.props.onSubmit(e);
	//     }
	//   }
	// };

	render() {
		const {
			id,
			label,
			value,
			onChange,
			error,
			helperText,
			required,
			type,
			name,
			placeholder,
			style,
			marginTop,
			onKeyPress,
			icon,
			disabled
		} = this.props;

		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					marginTop: marginTop || 0
				}}>
				<label style={style} className="auth-form-input-header" htmlFor={id}>
					{label} <span style={{ fontSize: '14px' }}>{required ? '*' : ''}</span>
				</label>
				<div className="common-basic-input-wrapper full-width" onClick={this.handleClick}>
					{this.props.toolTip ? (
						<Tooltip arrow title={this.props.toolTip}>
							<input
								onKeyPress={onKeyPress}
								disabled={disabled}
								name={name}
								id={id}
								type={type}
								value={value}
								onChange={onChange}
								required={required}
								placeholder={placeholder}
								className="common-basic-input"
								// onKeyPress={this.handleKeyPress}
							/>
						</Tooltip>
					) : (
						<>
							<input
								disabled={disabled}
								onKeyPress={onKeyPress}
								name={name}
								id={id}
								type={type}
								value={value}
								onChange={onChange}
								required={required}
								placeholder={placeholder}
								className="common-basic-input"
								// onKeyPress={this.handleKeyPress}
							/>
							{icon ? icon : null}
						</>
					)}
				</div>
				{error && <span className="error">{helperText}</span>}
			</div>
		);
	}
}

export default BasicTextField;
